import React from 'react';
import { Flex, Text } from '@chakra-ui/react';
import { IProject } from '../../../types/global/helper';
import { FONT_ENUM } from '../../../types/global/fonts.types';
import { ColorScheme, theme } from '../../../constants/theme';

interface IInformationDisplay {
    project: IProject;
    themeStyle: ColorScheme;
}
const InformationDisplay: React.FC<IInformationDisplay> = ({ project, themeStyle }) => {
    return (
        <Flex
            flexDirection="column"
            position="fixed"
            top={0}
            left={0}
            right={0}
            bottom={0}
            justifyContent={'center'}
            zIndex={999}
            backgroundColor={'rgba(0,0,0,0.4)'}
            pl={'10%'}>
            <Text color={theme[themeStyle].true_white} fontFamily={FONT_ENUM.REGULAR_HEADER} fontSize={24}>
                You're watching
            </Text>
            <Text color={theme[themeStyle].true_white} fontFamily={FONT_ENUM.REGULAR_HEADER} fontSize={50}>
                {project.title}
            </Text>
        </Flex>
    );
};

export { InformationDisplay };
